<template>
  <div :class="['rotating-container', play && 'rotating-container--spinning']">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RotatingContainer',
  props: {
    play: {
      type: Boolean,
      required: false,
      default: () => true,
    },
  },
}
</script>

<style lang="scss" scoped>
.rotating-container {
  display: flex;
  align-items: center;
  justify-content: center;

  &--spinning {
    animation-name: spin;
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
